var render = function render(){var _vm=this,_c=_vm._self._c;return _c('implement-page',{attrs:{"type":"curtain"}})
}
var staticRenderFns = []

export { render, staticRenderFns }